export default __webpack_public_path__ + "static/media/cancel-icon.8a6a207b.svg";